function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 5.622L6.667 8.82v.118c0 3.85 2.138 7.414 5.581 9.302l.252.138.252-.138c3.443-1.888 5.581-5.453 5.581-9.302V8.82L12.5 5.622zM12.5 20c-.283 0-.565-.069-.816-.207l-.252-.139C7.464 17.48 5 13.374 5 8.938V8.82c0-.584.325-1.126.848-1.414l5.835-3.199a1.712 1.712 0 011.633 0l5.834 3.198c.525.289.85.831.85 1.415v.118c0 4.436-2.464 8.542-6.432 10.716l-.251.138A1.7 1.7 0 0112.5 20z"
});

function SvgSafety(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
}

export default SvgSafety;